let tries = 0

export function trackCustomEvent(eventName: string, options = {}) {
  const fbq = window.fbq
  if (fbq) {
    fbq('trackCustom', eventName, options)
  } else if (tries < 3) {
    setTimeout(() => trackCustomEvent(eventName, options), 1000)
    tries++
  } else {
    console.log('Unable to load Facebook Pixel')
  }
}

export function sendCompleteFlowEvent(metaData = {}) {
  const hasItemIdFromScreeners = window.location.search.includes('itemId')
  const hasResultIdFromHealthTools = window.location.search.includes('resultId')

  if (hasResultIdFromHealthTools || hasItemIdFromScreeners) {
    return
  }
  /**
   * Need to follow the Object Properties and Value Type from Facebook pixel document
   *  status: Boolean
   *  metaData: Custom Properties
   *    - risk_level: String
   */

  trackCustomEvent('CompleteFlow', { status: true, ...metaData })
}
